import CTASpacer from '../ctaSpacer'
import Link from './link'

const CTACard = ({
  titleRow1,
  titleRow2,
  description,
  buttonName,
  link,
  className = '',
  topSpacer = true,
  bottomSpacer = true,
}) => {
  const base = 'flex flex-col';
  return (
    <section className={`${base} ${className}`}>
      {topSpacer ? <CTASpacer /> : <></>}
      <Link
        link={link}
        titleRow1={titleRow1}
        titleRow2={titleRow2}
        description={description}
        buttonName={buttonName}
      />
      {bottomSpacer ? <CTASpacer /> : <></>}
    </section>
  )
}

export default CTACard
